import DonutChart from '../DonutChart/DonutChart';
import styles from './DataUsage.module.css';

function DataUsage({ data }) {
  return (
    <div className={styles.card}>
      <div className={styles.donutWrapper}>
        <DonutChart data={data} size={320} strokeWidth={19} gap={24} />
        <div className={styles.legend}>
          {data.map((d) => (
            <div key={d.name} className={styles.legendItem}>
              <span className={styles.legendDot} style={{ background: d.color }} />
              {d.name.toUpperCase()}: <strong style={{ color: 'var(--color-text-primary)', marginLeft: 3 }}>{d.value} GiB</strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DataUsage;
